import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SectionTitle from '@/components/base/SectionTitle';
import MediaCard from '@/components/base/MediaCard';
import { getLatest } from '@/utils/media';

export default function LatestSection() {
  const { t } = useTranslation();
  const latest = getLatest(12);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          icon="ri-time-line"
          title={t('latest')}
          desc={t('latestDesc')}
          action={
            <Link
              to="/category/movie"
              className="inline-flex w-fit items-center gap-1 rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition hover:bg-background-200 cursor-pointer whitespace-nowrap"
            >
              {t('viewAll')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
          {latest.map((item) => (
            <MediaCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}